import * as React from "react"

const WifiIcon = (props) => (
  <svg
    width={16}
    height={17}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2.938 12.188c.597 0 1.124.527 1.124 1.124 0 .633-.527 1.126-1.125 1.126a1.11 1.11 0 0 1-1.124-1.126c0-.597.492-1.124 1.125-1.124Zm0-1.688a2.798 2.798 0 0 0-2.813 2.813 2.777 2.777 0 0 0 2.813 2.812 2.798 2.798 0 0 0 2.812-2.813A2.82 2.82 0 0 0 2.937 10.5Zm12.902 5.203C15.629 7.336 8.879.621.547.41.3.375.125.586.125.832v.844c0 .21.176.387.387.422a14.032 14.032 0 0 1 13.64 13.64c.036.211.211.387.422.387h.844c.246 0 .457-.176.422-.422Zm-4.781 0C10.848 10.008 6.242 5.403.547 5.191c-.246-.035-.422.176-.422.422v.844c0 .211.176.387.387.422a9.255 9.255 0 0 1 8.86 8.86c.034.21.21.421.421.421h.844c.246-.035.457-.21.422-.457Z"
      fill="#4952E3"
    />
  </svg>
)

export default WifiIcon
